module.exports = __webpack_public_path__ + "img/jcbg.2771402e.png";